import { Card, TinyTable } from '@rematter/ui-web';
import { useAtomValue } from 'jotai';

import { $overviewRecentInvoices } from '../../_state/financeOverview.state';

import { useRecentInvoicesColumns } from './hooks/useRecentInvoicesColumns';

import { useTranslations } from '@/finance/i18n/useTranslations';

export const OverviewRecentInvoices = () => {
  const t = useTranslations();
  const { data, isFetching } = useAtomValue($overviewRecentInvoices);
  const { columns } = useRecentInvoicesColumns();

  const invoices = data?.invoices ?? [];

  return (
    <Card className="@OverviewRecentInvoices flex h-full flex-col">
      <h3 className="text-lg font-semibold">
        {t.overview.recentInvoices.title}
      </h3>
      <p className="text-sm text-neutral">
        {t.overview.recentInvoices.subtitle}
      </p>
      {!isFetching && invoices.length === 0 ? (
        <p className="py-8 text-center text-sm text-neutral">
          {t.overview.recentInvoices.empty}
        </p>
      ) : (
        <TinyTable
          data={invoices}
          isLoading={isFetching}
          rowKey={(row) => row.id}
          columns={columns}
          className="overflow-y-auto"
          headerClassName="bg-neutral/8 font-semibold text-neutral [&_*]:opacity-100"
          rowClassName="bg-white"
        />
      )}
    </Card>
  );
};
